import SlidingContainer from './sliding-container.element.js';

export default SlidingContainer;

SlidingContainer.define('wje-sliding-container', SlidingContainer);
